import styled from "styled-components";
import CategoryItem from "../../components/common/CategoryItem";
import LayoutCatalog from "../../components/layout/LayoutCatalog";
import { Query } from "react-apollo";
import getUndef from "../../lib/get-undef";
import { GET_COLLECTIONS } from "../../queries/Collections";
import HelmetComponent from "../../components/layout/HelmetComponent";
import { CityContext } from "../../components/context/CityContext";
import { useContext } from "react";

const Page = () => {
  const { cityNameForSeo, workingHours } = useContext(CityContext);

  return (
    <LayoutCatalog head={"Весь каталог"} nameArrow="НА ГЛАВНУЮ" href="/">
      <HelmetComponent
        title={`МИКАfood  - Меню - Доставка еды в ${cityNameForSeo}`}
        description={`Большой выбор пицц, салатов на любой вкус, печеная картошка с различными начинками, картофель фри, настоящие шашлыки на углях, ароматная шаурма, фирменные хачапури. Доставка ${workingHours}`}
      />
      <Table>
        <Query
          query={GET_COLLECTIONS}
          variables={{
            where: {
              metafields_some: {
                key: "hideCategory",
                value_not: "Да",
              },
            },
          }}
        >
          {({ loading, error, data }: any) => {
            if (loading || error) {
              return null;
            }

            const collections = getUndef(() => data.shop.collections);

            return collections
              .filter(
                ({ metafields }) =>
                  !metafields.find(
                    ({ key, value }) => key === "hideCategory" && value === "Да"
                  )
              )
              .map((i) => <Item key={i.name} {...i} />);
          }}
        </Query>
      </Table>
    </LayoutCatalog>
  );
};

const Item = styled(CategoryItem)`
  flex-basis: calc(33.3333% - 20px);
  max-width: calc(33.3333% - 20px);
  margin: 0 20px 20px 0;
  width: 250px;

  @media (max-width: 1200px) {
    flex-basis: calc(50% - 20px);
    max-width: calc(50% - 20px);
  }

  @media (max-width: 800px) {
    flex-basis: 100%;
    max-width: 100%;
    margin-right: 0;
  }
`;

const Table = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-right: -20px;

  @media (max-width: 800px) {
    margin-right: 0;
  }
`;

export default Page;
